<template>
  <div class="editjob-form">
    <el-dialog
      title="修改职务"
      :visible="editShow"
      width="30%"
      @close="dialogClose"
      @open="dialogOpen"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="职务名称">
          <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="权限字符">
          <el-input
            v-model="form.permission"
            placeholder="请输入权限字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色顺序">
          <el-input v-model="form.order" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.menuStatus">
            <el-radio label="正常"></el-radio>
            <el-radio label="停用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="展开/折叠" name="type"></el-checkbox>
            <el-checkbox label="全选/全不选" name="type"></el-checkbox>
            <el-checkbox label="父子联动" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
      <div class="btns">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  name: "",
  props: ["editShow", "jobItemData"],
  data() {
    return {
      form: {
        name: "",
        id: 0,
        // permission: "",
        // menuStatus: "正常",
        // type: [],
        // order: 0,
      },
    };
  },
  inject: ["refresh"],
  methods: {
    confirm() {
      this.post(this.$url.updateSchoolJob, {
        id: this.form.id,
        schoolId: this.user.schoolId,
        jobName: this.form.name,
      }).then((res) => {
        if (res.code != 200) return this.$message.error(res.msg);
        this.$message.success("修改成功");
        this.dialogClose();
        this.refresh();
      });
    },
    dialogClose() {
      this.$emit("update:editShow", false);
    },
    dialogOpen() {
      this.form.name = this.jobItemData.jobName;
      this.form.id = this.jobItemData.id;
    },
  },
};
</script>
  
  <style lang="scss" scoped >
@import "./editJob.scss";
</style>